import { useContext, useEffect } from "react";
import { ModalSettingContext } from "../../index";
import s from './index.module.css';
import { useRegularity } from '@common/RegularityType/hooks/useRegularity'
import RegularityType from '@common/RegularityType'
import { InputSelect } from "@UI/InputNew";

export const ChoiceRegularity = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    
    const {
     regularityType,
     setRegularityType,
     bindRegularityType,

     regularity,
     setRegularity,
     changeRegularity,
     addRegularity,
     deleteRegularity
     
  } = useRegularity({
        placeholderByChoosingTheTypeOfRegularity: 'Регулярность урока',
        availableFields: {
            daily: true,
            monthly: true,
            annually: true,
            manually: false
        },
        timeRange: true
    });

    useEffect(()=>{
        setFieldInState({field: 'customDaysValue', value: {type: regularityType, value: regularity[regularityType]} })
    }, [regularityType, regularity])

    return (
        <div className={s.wrapper}>
            <div className={s.inputWrapper}>
              <InputSelect
                newDesign
                className={s.select}
                classNameBox={s.selectBox}
                classNamePlaseholder={s.plaseholder}
                {...bindRegularityType}
              />
            </div>
            <RegularityType 
                className={s.regularity}
                regularity={regularity}
                type={regularityType}
                changeRegularity={changeRegularity}
                addRegularity={addRegularity}
                deleteRegularity={deleteRegularity}
                timeRange={true}
            />
        </div>
    )
}